import { el } from '../core/dom.js';

/**
 * @param {string} label
 * @param {{ variant?: string, href?: string, onClick?: (event: Event) => void, type?: string, disabled?: boolean, className?: string }} [opts]
 */
export function button(label, opts = {}) {
  const variant = opts.variant || 'ghost';
  const className = `btn btn-${variant}${opts.className ? ` ${opts.className}` : ''}`;
  if (opts.href) {
    return el('a', { class: className, href: opts.href, onClick: opts.onClick }, label);
  }
  return el('button', {
    class: className,
    type: opts.type || 'button',
    disabled: opts.disabled ? true : null,
    onClick: opts.onClick,
  }, label);
}
